<script setup lang="ts">
import { useI18n } from "~/composables/useI18n";

const t = useI18n();
</script>

<template>
  <div class="recruiter-cta">
    <p class="recruiter-cta-bubble anim-pulse-gentle">
      {{ t("downloadResume.recruiterCta") }}
    </p>
  </div>
</template>

<style scoped>
.recruiter-cta {
  display: flex;
  justify-content: center;
}

.recruiter-cta-bubble {
  position: relative;
  background-color: var(--color-primary-50);
  color: var(--color-primary-800);
  font-size: 0.875rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  max-width: max-content;
}

.recruiter-cta-bubble::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid var(--color-primary-50);
}

:global(.dark) .recruiter-cta-bubble {
  background-color: var(--color-primary-900);
  color: var(--color-primary-100);
}

:global(.dark) .recruiter-cta-bubble::after {
  border-top-color: var(--color-primary-900);
}
</style>
